export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-shape/src/array.js
// module id = ../../../../d3-shape/src/array.js
// module chunks = 4